import { CraftedItem } from 'common/ITEMS/Item';

const gems = {
  VOLATILE_FRAGRANCE: {
    id: 227448,
    name: 'Volatile Fragrance',
    icon: 'trade_alchemy_potionc3',
    craftQuality: 1,
  },
  VERSATILE_SAPPHIRE_R1: {
    id: 213474,
    name: 'Versatile Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem_color3',
    craftQuality: 1,
  },
  VERSATILE_SAPPHIRE_R2: {
    id: 213475,
    name: 'Versatile Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem_color3',
    craftQuality: 2,
  },
  VERSATILE_SAPPHIRE_R3: {
    id: 213476,
    name: 'Versatile Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem_color3',
    craftQuality: 3,
  },
  VERSATILE_RUBY_R1: {
    id: 213459,
    name: 'Versatile Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_2',
    craftQuality: 1,
  },
  VERSATILE_RUBY_R2: {
    id: 213460,
    name: 'Versatile Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_2',
    craftQuality: 2,
  },
  VERSATILE_RUBY_R3: {
    id: 213461,
    name: 'Versatile Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_2',
    craftQuality: 3,
  },
  VERSATILE_ONYX_R1: {
    id: 213495,
    name: 'Versatile Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_1',
    craftQuality: 1,
  },
  VERSATILE_ONYX_R2: {
    id: 213496,
    name: 'Versatile Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_1',
    craftQuality: 2,
  },
  VERSATILE_ONYX_R3: {
    id: 213497,
    name: 'Versatile Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_1',
    craftQuality: 3,
  },
  VERSATILE_EMERALD_R1: {
    id: 213483,
    name: 'Versatile Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_1',
    craftQuality: 1,
  },
  VERSATILE_EMERALD_R2: {
    id: 213484,
    name: 'Versatile Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_1',
    craftQuality: 2,
  },
  VERSATILE_EMERALD_R3: {
    id: 213485,
    name: 'Versatile Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_1',
    craftQuality: 3,
  },
  VERSATILE_AMBER_R1: {
    id: 213510,
    name: 'Versatile Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_1',
    craftQuality: 1,
  },
  VERSATILE_AMBER_R2: {
    id: 213511,
    name: 'Versatile Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_1',
    craftQuality: 2,
  },
  VERSATILE_AMBER_R3: {
    id: 213512,
    name: 'Versatile Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_1',
    craftQuality: 3,
  },
  TINKER_HEARTSEEKING_HEALTH_INJECTOR_R1: {
    id: 221910,
    name: 'Tinker: Heartseeking Health Injector',
    icon: 'inv_tinkermodule_red',
    craftQuality: 1,
  },
  TINKER_HEARTSEEKING_HEALTH_INJECTOR_R2: {
    id: 221908,
    name: 'Tinker: Heartseeking Health Injector',
    icon: 'inv_tinkermodule_red',
    craftQuality: 2,
  },
  TINKER_HEARTSEEKING_HEALTH_INJECTOR_R3: {
    id: 221909,
    name: 'Tinker: Heartseeking Health Injector',
    icon: 'inv_tinkermodule_red',
    craftQuality: 3,
  },
  TINKER_EARTHEN_DELIVERY_DRILL_R1: {
    id: 221906,
    name: 'Tinker: Earthen Delivery Drill',
    icon: 'inv_tinkermodule_yellow',
    craftQuality: 1,
  },
  TINKER_EARTHEN_DELIVERY_DRILL_R2: {
    id: 221904,
    name: 'Tinker: Earthen Delivery Drill',
    icon: 'inv_tinkermodule_yellow',
    craftQuality: 2,
  },
  TINKER_EARTHEN_DELIVERY_DRILL_R3: {
    id: 221905,
    name: 'Tinker: Earthen Delivery Drill',
    icon: 'inv_tinkermodule_yellow',
    craftQuality: 3,
  },
  SOLID_AMBER_R1: {
    id: 213515,
    name: 'Solid Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem_color4',
    craftQuality: 1,
  },
  SOLID_AMBER_R2: {
    id: 213516,
    name: 'Solid Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem_color4',
    craftQuality: 2,
  },
  SOLID_AMBER_R3: {
    id: 213517,
    name: 'Solid Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem_color4',
    craftQuality: 3,
  },
  ROBUST_FRAGRANCE: {
    id: 227449,
    name: 'Robust Fragrance',
    icon: 'trade_alchemy_potionc6',
    craftQuality: 1,
  },
  REFURBISHED_TINKER_SUPERCOLLIDE_O_TRON: {
    id: 225243,
    name: 'Refurbished Tinker: Supercollide-O-Tron',
    icon: 'inv_10_engineering2_tinkermodules_color5',
    craftQuality: 1,
  },
  REFURBISHED_TINKER_SHADOWFLAME_ROCKETS: {
    id: 225244,
    name: 'Refurbished Tinker: Shadowflame Rockets',
    icon: 'inv_10_engineering2_tinkermodules_color3',
    craftQuality: 1,
  },
  REFURBISHED_TINKER_PLANE_DISPLACER: {
    id: 225242,
    name: 'Refurbished Tinker: Plane Displacer',
    icon: 'inv_10_engineering2_tinkermodules_color6',
    craftQuality: 1,
  },
  REFURBISHED_TINKER_ALARM_O_TURRET: {
    id: 225241,
    name: 'Refurbished Tinker: Alarm-O-Turret',
    icon: 'inv_10_engineering2_tinkermodules_color1',
    craftQuality: 1,
  },
  QUICK_SAPPHIRE_R1: {
    id: 213468,
    name: 'Quick Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_3',
    craftQuality: 1,
  },
  QUICK_SAPPHIRE_R2: {
    id: 213469,
    name: 'Quick Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_3',
    craftQuality: 2,
  },
  QUICK_SAPPHIRE_R3: {
    id: 213470,
    name: 'Quick Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_3',
    craftQuality: 3,
  },
  QUICK_RUBY_R1: {
    id: 213453,
    name: 'Quick Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_3',
    craftQuality: 1,
  },
  QUICK_RUBY_R2: {
    id: 213454,
    name: 'Quick Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_3',
    craftQuality: 2,
  },
  QUICK_RUBY_R3: {
    id: 213455,
    name: 'Quick Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_3',
    craftQuality: 3,
  },
  QUICK_ONYX_R1: {
    id: 213492,
    name: 'Quick Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_3',
    craftQuality: 1,
  },
  QUICK_ONYX_R2: {
    id: 213493,
    name: 'Quick Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_3',
    craftQuality: 2,
  },
  QUICK_ONYX_R3: {
    id: 213494,
    name: 'Quick Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_3',
    craftQuality: 3,
  },
  QUICK_EMERALD_R1: {
    id: 213486,
    name: 'Quick Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem_color2',
    craftQuality: 1,
  },
  QUICK_EMERALD_R2: {
    id: 213487,
    name: 'Quick Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem_color2',
    craftQuality: 2,
  },
  QUICK_EMERALD_R3: {
    id: 213488,
    name: 'Quick Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem_color2',
    craftQuality: 3,
  },
  QUICK_AMBER_R1: {
    id: 213504,
    name: 'Quick Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_4',
    craftQuality: 1,
  },
  QUICK_AMBER_R2: {
    id: 213505,
    name: 'Quick Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_4',
    craftQuality: 2,
  },
  QUICK_AMBER_R3: {
    id: 213506,
    name: 'Quick Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_4',
    craftQuality: 3,
  },
  MASTERFUL_SAPPHIRE_R1: {
    id: 213471,
    name: 'Masterful Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_1',
    craftQuality: 1,
  },
  MASTERFUL_SAPPHIRE_R2: {
    id: 213472,
    name: 'Masterful Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_1',
    craftQuality: 2,
  },
  MASTERFUL_SAPPHIRE_R3: {
    id: 213473,
    name: 'Masterful Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_1',
    craftQuality: 3,
  },
  MASTERFUL_RUBY_R1: {
    id: 213456,
    name: 'Masterful Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_1',
    craftQuality: 1,
  },
  MASTERFUL_RUBY_R2: {
    id: 213457,
    name: 'Masterful Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_1',
    craftQuality: 2,
  },
  MASTERFUL_RUBY_R3: {
    id: 213458,
    name: 'Masterful Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color4_1',
    craftQuality: 3,
  },
  MASTERFUL_ONYX_R1: {
    id: 213498,
    name: 'Masterful Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem_color1',
    craftQuality: 1,
  },
  MASTERFUL_ONYX_R2: {
    id: 213499,
    name: 'Masterful Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem_color1',
    craftQuality: 2,
  },
  MASTERFUL_ONYX_R3: {
    id: 213500,
    name: 'Masterful Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem_color1',
    craftQuality: 3,
  },
  MASTERFUL_EMERALD_R1: {
    id: 213480,
    name: 'Masterful Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_3',
    craftQuality: 1,
  },
  MASTERFUL_EMERALD_R2: {
    id: 213481,
    name: 'Masterful Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_3',
    craftQuality: 2,
  },
  MASTERFUL_EMERALD_R3: {
    id: 213482,
    name: 'Masterful Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_3',
    craftQuality: 3,
  },
  MASTERFUL_AMBER_R1: {
    id: 213507,
    name: 'Masterful Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_3',
    craftQuality: 1,
  },
  MASTERFUL_AMBER_R2: {
    id: 213508,
    name: 'Masterful Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_3',
    craftQuality: 2,
  },
  MASTERFUL_AMBER_R3: {
    id: 213509,
    name: 'Masterful Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_3',
    craftQuality: 3,
  },
  INVIGORATING_FRAGRANCE: {
    id: 227447,
    name: 'Invigorating Fragrance',
    icon: 'trade_alchemy_potionc2',
    craftQuality: 1,
  },
  INSIGHTFUL_BLASPHEMITE_R1: {
    id: 213738,
    name: 'Insightful Blasphemite',
    icon: 'inv_misc_metagem_b',
    craftQuality: 1,
  },
  INSIGHTFUL_BLASPHEMITE_R2: {
    id: 213739,
    name: 'Insightful Blasphemite',
    icon: 'inv_misc_metagem_b',
    craftQuality: 2,
  },
  INSIGHTFUL_BLASPHEMITE_R3: {
    id: 213740,
    name: 'Insightful Blasphemite',
    icon: 'inv_misc_metagem_b',
    craftQuality: 3,
  },
  INSCRUTABLE_FRAGRANCE: {
    id: 227445,
    name: 'Inscrutable Fragrance',
    icon: 'trade_alchemy_potionc4',
    craftQuality: 1,
  },
  ENDURING_BLOODSTONE: {
    id: 213747,
    name: 'Enduring Bloodstone',
    icon: 'inv_misc_cutgemsuperior6',
    craftQuality: 1,
  },
  ELUSIVE_BLASPHEMITE_R1: {
    id: 213744,
    name: 'Elusive Blasphemite',
    icon: 'inv_misc_gem_x4_metagem_cut',
    craftQuality: 1,
  },
  ELUSIVE_BLASPHEMITE_R2: {
    id: 213745,
    name: 'Elusive Blasphemite',
    icon: 'inv_misc_gem_x4_metagem_cut',
    craftQuality: 2,
  },
  ELUSIVE_BLASPHEMITE_R3: {
    id: 213746,
    name: 'Elusive Blasphemite',
    icon: 'inv_misc_gem_x4_metagem_cut',
    craftQuality: 3,
  },
  DETERMINED_BLOODSTONE: {
    id: 213749,
    name: 'Determined Bloodstone',
    icon: 'inv_misc_epicgem_uncut_01',
    craftQuality: 1,
  },
  DEADLY_SAPPHIRE_R1: {
    id: 213465,
    name: 'Deadly Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_2',
    craftQuality: 1,
  },
  DEADLY_SAPPHIRE_R2: {
    id: 213466,
    name: 'Deadly Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_2',
    craftQuality: 2,
  },
  DEADLY_SAPPHIRE_R3: {
    id: 213467,
    name: 'Deadly Sapphire',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color5_2',
    craftQuality: 3,
  },
  DEADLY_RUBY_R1: {
    id: 213462,
    name: 'Deadly Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem_color5',
    craftQuality: 1,
  },
  DEADLY_RUBY_R2: {
    id: 213463,
    name: 'Deadly Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem_color5',
    craftQuality: 2,
  },
  DEADLY_RUBY_R3: {
    id: 213464,
    name: 'Deadly Ruby',
    icon: 'inv_jewelcrafting_cut-standart-gem_color5',
    craftQuality: 3,
  },
  DEADLY_ONYX_R1: {
    id: 213489,
    name: 'Deadly Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_2',
    craftQuality: 1,
  },
  DEADLY_ONYX_R2: {
    id: 213490,
    name: 'Deadly Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_2',
    craftQuality: 2,
  },
  DEADLY_ONYX_R3: {
    id: 213491,
    name: 'Deadly Onyx',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color2_2',
    craftQuality: 3,
  },
  DEADLY_EMERALD_R1: {
    id: 213477,
    name: 'Deadly Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_2',
    craftQuality: 1,
  },
  DEADLY_EMERALD_R2: {
    id: 213478,
    name: 'Deadly Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_2',
    craftQuality: 2,
  },
  DEADLY_EMERALD_R3: {
    id: 213479,
    name: 'Deadly Emerald',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color1_2',
    craftQuality: 3,
  },
  DEADLY_AMBER_R1: {
    id: 213501,
    name: 'Deadly Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_2',
    craftQuality: 1,
  },
  DEADLY_AMBER_R2: {
    id: 213502,
    name: 'Deadly Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_2',
    craftQuality: 2,
  },
  DEADLY_AMBER_R3: {
    id: 213503,
    name: 'Deadly Amber',
    icon: 'inv_jewelcrafting_cut-standart-gem-hybrid_color3_2',
    craftQuality: 3,
  },
  CULMINATING_BLASPHEMITE_R1: {
    id: 213741,
    name: 'Culminating Blasphemite',
    icon: 'item_cutmetagemb',
    craftQuality: 1,
  },
  CULMINATING_BLASPHEMITE_R2: {
    id: 213742,
    name: 'Culminating Blasphemite',
    icon: 'item_cutmetagemb',
    craftQuality: 2,
  },
  CULMINATING_BLASPHEMITE_R3: {
    id: 213743,
    name: 'Culminating Blasphemite',
    icon: 'item_cutmetagemb',
    craftQuality: 3,
  },
  CUBIC_BLASPHEMIA_R1: {
    id: 217113,
    name: 'Cubic Blasphemia',
    icon: 'inv_stone_01',
    craftQuality: 1,
  },
  CUBIC_BLASPHEMIA_R2: {
    id: 217114,
    name: 'Cubic Blasphemia',
    icon: 'inv_stone_01',
    craftQuality: 2,
  },
  CUBIC_BLASPHEMIA_R3: {
    id: 217115,
    name: 'Cubic Blasphemia',
    icon: 'inv_stone_01',
    craftQuality: 3,
  },
  COGNITIVE_BLOODSTONE: {
    id: 213748,
    name: 'Cognitive Bloodstone',
    icon: 'inv_misc_epicgem_01',
    craftQuality: 1,
  },
} satisfies Record<string, CraftedItem>;

export default gems;
